import { ImageIcon, VideoIcon } from 'src/components/icons';

const FullImagePopup = () => {
  return (
    <div className="w-[300px] h-[250px] border rounded-2xl p-2">
      <div className="size-full bg-[#D3D3D3] rounded-2xl flex items-center justify-center">
        <ImageIcon className="size-14" />
      </div>
    </div>
  );
};

const FullVideoPopup = () => {
  return (
    <div className="w-[300px] h-[250px] border rounded-2xl p-2">
      <div className="size-full bg-[#D3D3D3] rounded-2xl flex items-center justify-center">
        <VideoIcon className="size-14" />
      </div>
    </div>
  );
};

const FullTextPopup = () => {
  return (
    <div className="w-[300px] h-[250px] border rounded-2xl p-2 flex flex-col gap-1">
      {Array(30)
        ?.fill({})
        ?.map((_, index) => (
          <div key={index} className="w-full h-1 bg-gray-300" />
        ))}
    </div>
  );
};

const ImageTopTextBottomPopup = () => {
  return (
    <div className="w-[300px] border flex flex-col gap-2 rounded-2xl p-2">
      <div className="w-full h-[170px] bg-[#D3D3D3] flex items-center justify-center rounded-2xl">
        <ImageIcon className="size-14" />
      </div>

      {Array(12)
        ?.fill({})
        ?.map((_, index) => (
          <div key={index} className="w-full h-1 bg-gray-300" />
        ))}
    </div>
  );
};

const ImageBootmTextTopPopup = () => {
  return (
    <div className="w-[300px] border flex flex-col gap-2 rounded-2xl p-2">
      {Array(12)
        ?.fill({})
        ?.map((_, index) => (
          <div key={index} className="w-full h-1 bg-gray-300" />
        ))}

      <div className="w-full h-[170px] bg-[#D3D3D3] flex items-center justify-center rounded-2xl">
        <ImageIcon className="size-14" />
      </div>
    </div>
  );
};

const ImageLeftTextRightPopup = () => {
  return (
    <div className="w-[500px] h-full border flex gap-2 rounded-2xl p-2">
      <div className="flex flex-col justify-around gap-2 w-1/2">
        {Array(17)
          ?.fill({})
          ?.map((_, index) => (
            <div key={index} className="w-full h-1 bg-gray-300" />
          ))}
      </div>
      <div className="w-1/2 h-[220px] bg-[#D3D3D3] flex items-center justify-center rounded-2xl">
        <ImageIcon className="size-14" />
      </div>
    </div>
  );
};

const ImageRightTextLeftPopup = () => {
  return (
    <div className="w-[500px] h-full border flex gap-2 rounded-2xl p-2">
      <div className="w-1/2 h-[220px] bg-[#D3D3D3] flex items-center justify-center rounded-2xl">
        <ImageIcon className="size-14" />
      </div>

      <div className="flex flex-col justify-around gap-2 w-1/2">
        {Array(17)
          ?.fill({})
          ?.map((_, index) => (
            <div key={index} className="w-full h-1 bg-gray-300" />
          ))}
      </div>
    </div>
  );
};

const PopupTypeGenerator = ({ popupTypeId }) => {
  const components = {
    1: <ImageTopTextBottomPopup />,
    2: <ImageRightTextLeftPopup />,
    3: <ImageLeftTextRightPopup />,
    4: <ImageBootmTextTopPopup />,
    5: <FullImagePopup />,
    6: <FullVideoPopup />,
    7: <FullTextPopup />,
  };

  return (
    <div className="flex justify-center">{components[popupTypeId] || <div className="text-center text-gray-500">خطای نوع اعلان</div>}</div>
  );
};

export default PopupTypeGenerator;
